<mat-card class="mat-card-flat mat-card-flat--dark">
  <mat-card-header>
    <mat-card-title>
      <h1>Downloads</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content id="recent-downloads-container">
    <mat-card class="mt-4">
      <div class="row">
        <div class="col-12">
          <div class="datatable-preheader datatable-filter-container filter-selection">
            <p class="mt-4">Files downloaded in the last 24 hours:</p>
          </div>
        </div>
      </div>

      <app-datatable
        data-automation-id="recent-downloads_202127113546"
        [columns]="columns"
        [dataUrl]="dataUrl"
        [defaultSort]="defaultSort"
        [scrollV]="false"
        [scrollH]="false"
        [disableFiltering]="true"
      ></app-datatable>
    </mat-card>

    <ng-template #fileNameTemplate let-row="row" let-value="value">
      <a
        class="mat-button-link"
        data-automation-id="recent-downloads_202127113550"
        tabindex="0"
        (click)="download(row)"
        (keyup.enter)="download(row)"
      >
        {{ value }}
        <i class="material-icons table-icon">system_update_alt</i>
      </a>
    </ng-template>

    <ng-template #relatedIdTemplate let-row="row" let-value="value">
      <ng-container *ngIf="row.relatedSystemTypeCode !== documentTypeCode.MedicalBillingDispute">
        <a
          class="mat-button-link"
          data-automation-id="recent-downloads_202127113554"
          tabindex="0"
          (click)="goToDetails(row.relatedSystemId, row.relatedSystemTypeCode)"
          (keyup.enter)="goToDetails(row.relatedSystemId, row.relatedSystemTypeCode)"
        >
          <span *ngIf="row.isRelatedToEntity">{{ row.relatedIdDisplayName }}</span>
          <span *ngIf="!row.isRelatedToEntity">{{ value }}</span>
        </a>
      </ng-container>

      <ng-container *ngIf="row.relatedSystemTypeCode === documentTypeCode.MedicalBillingDispute">
        <a class="mat-button-hide-link" data-automation-id="recent-downloads_202127113601">
          {{ value }}
        </a>
      </ng-container>
    </ng-template>

    <ng-template #relatedObjectTypeTemplate let-value="value">
      {{ value | wordifyFormatter }}
    </ng-template>
  </mat-card-content>
</mat-card>
